$(document).ready(function() {

  $('#webbys').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    arrows: false,
    speed: 1200
  });
  
  if(window.location.pathname == '/products/pickup-scheduler') {
    console.log('page confirmed');
    
  }

  $('#shop').fadeIn();
  
  // 7-E
//   $('#gotoshop').click(function(e) {
//     e.preventDefault();
//     console.log($('#gotoshop_pass').val());
//       window.location.href = 'https://freshgoods.shop'; 
//   });
  
//   $('#gotoshop_pass').keypress(function (e) {
//     if (e.which == 13) {
//         window.location.href = 'https://freshgoods.shop'; 
//       return false;
//     }
//   });
  
  
  $('.article__title').each(function () {
    var txt = $(this).find('a');
    var txttxt = $(txt).text().split('');
    
    $(this).find('a').html(function() {
      return $.map(txttxt, function(letter) {
        return "<span class='letter'>"+letter+"</span>"
      });
    });
    
    $('.letter').each(function() {
      $(this).contents().filter(function(){
          return this.nodeType == 3 // Text node
      }).each(function(){
          this.data = this.data.replace(/ /g, '\u00a0');
      });
    });
    
    
  });
  
  var firstUnmute = true;
  
  $('#vol').click(function() {
    
    if (firstUnmute) {
      $(this).removeClass('fa-volume-slash');
      if(Modernizr.touchevents) {
        $('#igtv').prop('muted', false);
        $(this).addClass('fa-volume-up');
      } else {
        $('#reg').prop('muted', false);
        $(this).addClass('fa-volume-up');
      }
      firstUnmute = false;
    } else {
      if($(this).hasClass('fa-volume-slash')) {
        $(this).removeClass('fa-volume-slash');
        if(Modernizr.touchevents) {
          $('#igtv').prop('muted', false);
          $(this).addClass('fa-volume-up');
        } else {
          $('#reg').prop('muted', false);
          $(this).addClass('fa-volume-up');
        }
      } else {
        $(this).removeClass('fa-volume-up');
        if(Modernizr.touchevents) {
          $('#igtv').prop('muted', true);
          $(this).addClass('fa-volume-slash');
        } else {
          $('#reg').prop('muted', true);
          $(this).addClass('fa-volume-slash');
        }

      }
    }
    
  });

  $('#SiteNav li:first-of-type').addClass('blacktive');

  $('.accordion').find('a').each(function() {
    var text = $(this).text().replace(/ /g, "&nbsp;");
    //.replace(' ', '&nbsp;');
    $(this).html(text);
  });

  $('.accordion').accordion({
    "transitionSpeed": 1000
  });

  $('.accordion').on('accordion.open', function() {
    console.log('it opened');
    var wha = $(this);
    $(wha).find('video').each(function() {
      $(this).attr('muted', true);
      $(this).attr('autoplay', true);
      $(this).attr('loop', true);
      $(this)[0].play();
    });
    $('.accordion').each(function(i, o) {
        if($('.accordion').index(wha) != i) {
          $(this).slideUp();
        } 
        else {
          //$(this).slideDown();
        }
      });
  });

  $('.accordion').on('accordion.close', function() {
    var wha = $('#pswitch').find('.active');
    console.log($(wha).text());
    $(wha).find('video').each(function() {
      $(this)[0].stop();
    });
    if($(wha).text().toLowerCase() == 'all') {
      $('.accordion').slideDown();  
    } else {
      $('.accordion').each(function() {
        if($(this).attr('data-filter') != $(wha).text().toLowerCase()) {
          //$(this).slideDown();
        } 
        else {
          $(this).slideDown();
        }
      });
    }
  });

  

  $('#pswitch li').click(function() {
    console.log($(this).text().toLowerCase());
    var wha = $(this).text().toLowerCase();
    $('#pswitch li').removeClass('active');
    $(this).addClass('active');
    if(wha == 'all') {
      $('.accordion').slideDown();  
    } else {
      $('.accordion').each(function() {
        if($(this).attr('data-filter') != wha) {
          $(this).slideUp();
        } 
        //else {
        //  $(this).slideDown();
        //}
      });
      $('[data-filter="'+wha+'"]').slideDown();

    }
  });
  
  $('#SiteNav li:last-of-type').find('a').attr('href', 'mailto:info@joefreshgoods.com');
  $('#SiteNav li:first-of-type').find('a').addClass('shop');
  $('#SiteNav li:last-of-type').find('a').addClass('mail');
  $('#SiteNav li:nth-of-type(5)').find('a').addClass('tclive');
  $('.mobile-nav__item:last-of-type').find('a').attr('href', 'mailto:info@joefreshgoods.com');
  $('.mobile-nav__item:first-of-type').find('a').addClass('shop');
  $('.mobile-nav__item:last-of-type').find('a').addClass('mail');

  $('.site-nav a').click(function(e) {
    if($(this).hasClass('shop')) {
    	window.location.href = '/collections/shop';  
    }

    if($(this).hasClass('tclive')) {
    	window.location.href = '/pages/terms-conditions';  
    }
    
    if(!$(this).hasClass('mail')) {
    	e.preventDefault();
    }

    $('#shopify-section-header').css({
      position: 'fixed'
    });
    $('#PageContainer').css({
      'padding-top': '75px'
    });
    var link = $(this).attr('href');
    $("html, body").animate({ scrollTop: $(link).offset().top - 75 });

    $('.site-nav li').removeClass('blacktive');
    $(this).parent('li').addClass('blacktive');
  });
  

   function makeTimer() {
        var endTimes = [new Date("10 July 2020 13:00:00 GMT-06:00"), new Date("24 March 2019 9:56:00 GMT-06:00"), new Date("1 October 2019 9:56:00 GMT-06:00")];

        var now = new Date();
            now = (Date.parse(now) / 1000);

        $('.timer').each(function(i, o) {

          var endTime = (Date.parse(endTimes[i]) / 1000);
          var timeLeft = endTime - now;
            
            var days = Math.floor(timeLeft / 86400); 
            var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
            var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
            var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
  
            if (days < "10") { days = "0" + days; }
            if (hours < "10") { hours = "0" + hours; }
            if (minutes < "10") { minutes = "0" + minutes; }
            if (seconds < "10") { seconds = "0" + seconds; }

            $(this).find(".days").html("<p>" + days + "<span>D</span></p>");
            $(this).find(".hours").html("<p>" + hours + "<span>H</span></p>");
            $(this).find(".seconds").html("<p>" + seconds + "<span>S</span></p>");   
        });    
    }

    setInterval(function() { makeTimer(); }, 1000);
});


$(window).load(function() {
  // MicroModal.init();
  $('.cd-mod-close').click(function(e) {
    // e.preventDefault();
    console.log($(this));
    // MicroModal.close();
  });
});